import { render } from "./MediaObject.vue?vue&type=template&id=2b5fe67b"
import script from "./MediaObject.vue?vue&type=script&lang=js"
export * from "./MediaObject.vue?vue&type=script&lang=js"

import "./MediaObject.vue?vue&type=style&index=0&id=2b5fe67b&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__